/**
 * Belirli market ve language kombinasyonlarında Wingie metinlerini Enuygun ile değiştirir.
 * Replace configs are currently unused; returns text unchanged.
 * @param text - Değiştirilecek metin
 * @param _market - Market kodu (örn: 'tr', 'us') — reserved for future configs
 * @param _language - Dil kodu (örn: 'ru', 'en') — reserved for future configs
 * @returns Metin (şu an değiştirilmeden)
 */
export const replaceWingieWithEnuygun = (text: string, _market: string, _language: string): string => {
  return text
}
